document.addEventListener('DOMContentLoaded', function() {
  // =============================================
  // Mobile Menu
  // =============================================
  const menuToggle = document.querySelector('.header__menu-toggle');
  const headerNav = document.querySelector('.header__nav');
  const navClose = document.querySelector('.header__nav-close');
  const headerOverlay = document.querySelector('.header__overlay');

  function openMobileMenu() {
    menuToggle.classList.add('active');
    menuToggle.setAttribute('aria-expanded', 'true');
    headerNav.classList.add('open');
    headerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    menuToggle.classList.remove('active');
    menuToggle.setAttribute('aria-expanded', 'false');
    headerNav.classList.remove('open');
    headerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      if (headerNav.classList.contains('open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  if (navClose) {
    navClose.addEventListener('click', closeMobileMenu);
  }

  if (headerOverlay) {
    headerOverlay.addEventListener('click', closeMobileMenu);
  }

  // Close menu on nav link click
  const navLinks = document.querySelectorAll('.header__nav-link');
  navLinks.forEach(function(link) {
    link.addEventListener('click', closeMobileMenu);
  });

  // Swipe to close menu (swipe right to close)
  let touchStartX = 0;
  let touchEndX = 0;

  if (headerNav) {
    headerNav.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    headerNav.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      // Swipe right (from left to right) to close
      if (touchEndX - touchStartX > 50) {
        closeMobileMenu();
      }
    }, { passive: true });
  }

  // =============================================
  // Header Scroll Effect
  // =============================================
  const header = document.querySelector('.header');

  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // =============================================
  // Hero Carousel
  // =============================================
  const heroSlides = document.querySelectorAll('.hero__slide');
  const heroIndicators = document.querySelectorAll('.hero__indicator');
  let currentSlide = 0;
  let heroInterval = null;

  function showSlide(index) {
    heroSlides.forEach(function(slide, i) {
      slide.classList.remove('active', 'prev');
      if (i < index) {
        slide.classList.add('prev');
      }
    });

    heroIndicators.forEach(function(indicator) {
      indicator.classList.remove('active');
    });

    if (heroSlides[index]) {
      heroSlides[index].classList.add('active');
    }

    if (heroIndicators[index]) {
      heroIndicators[index].classList.add('active');
    }

    currentSlide = index;
  }

  function nextSlide() {
    const next = (currentSlide + 1) % heroSlides.length;
    showSlide(next);
  }

  function prevSlide() {
    const prev = (currentSlide - 1 + heroSlides.length) % heroSlides.length;
    showSlide(prev);
  }

  function startHeroAutoplay() {
    if (heroInterval) {
      clearInterval(heroInterval);
    }
    heroInterval = setInterval(nextSlide, 3000);
  }

  if (heroSlides.length > 1) {
    showSlide(0);
    startHeroAutoplay();

    heroIndicators.forEach(function(indicator, index) {
      indicator.addEventListener('click', function() {
        showSlide(index);
        startHeroAutoplay();
      });
    });

    // Arrow navigation
    const prevArrow = document.querySelector('.hero__arrow--prev');
    const nextArrow = document.querySelector('.hero__arrow--next');

    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.stopPropagation();
        prevSlide();
        startHeroAutoplay();
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function(e) {
        e.stopPropagation();
        nextSlide();
        startHeroAutoplay();
      });
    }

    const heroSection = document.querySelector('.hero');

    if (heroSection) {
      // Pause on hover (desktop)
      heroSection.addEventListener('mouseenter', function() {
        if (heroInterval) {
          clearInterval(heroInterval);
          heroInterval = null;
        }
      });

      heroSection.addEventListener('mouseleave', function() {
        startHeroAutoplay();
      });

      // Click navigation (desktop) - click left/right side of hero
      heroSection.addEventListener('click', function(e) {
        // Don't trigger if clicking buttons, links, or indicators
        if (e.target.closest('a, button, .hero__indicator, .hero__buttons')) {
          return;
        }

        const rect = heroSection.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const sectionWidth = rect.width;

        if (clickX < sectionWidth * 0.3) {
          // Clicked left 30% - go to previous
          prevSlide();
        } else if (clickX > sectionWidth * 0.7) {
          // Clicked right 30% - go to next
          nextSlide();
        }
        startHeroAutoplay();
      });

      // Swipe support (mobile)
      let touchStartX = 0;
      let touchEndX = 0;
      let touchStartY = 0;
      let touchEndY = 0;
      const minSwipeDistance = 50;

      heroSection.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      heroSection.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        handleSwipe();
      }, { passive: true });

      function handleSwipe() {
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;

        // Only register horizontal swipes (ignore vertical scrolling)
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
          if (deltaX > 0) {
            // Swiped right - go to previous
            prevSlide();
          } else {
            // Swiped left - go to next
            nextSlide();
          }
          startHeroAutoplay();
        }
      }
    }
  }

  // =============================================
  // Animated Graph
  // =============================================
  const graphSection = document.querySelector('.results');
  const graphBaseline = document.querySelector('.graph__baseline');
  const graphNattyLine = document.querySelector('.graph__natty-line');
  const graphBaselineDot = document.querySelector('.graph__dot--baseline');
  const graphNattyDot = document.querySelector('.graph__dot--natty');
  const graphGlow = document.querySelector('.graph__glow');
  const graphTooltipBaseline = document.querySelector('.graph__tooltip--baseline');
  const graphTooltipNatty = document.querySelector('.graph__tooltip--natty');
  const graphTooltipBaselineValue = document.querySelector('.graph__tooltip--baseline .graph__tooltip-value');
  const graphTooltipNattyValue = document.querySelector('.graph__tooltip--natty .graph__tooltip-value');
  const graphTooltipChange = document.querySelector('.graph__tooltip-change');

  let graphAnimated = false;
  let baselineValue = 0;
  let nattyValue = 0;

  function animateGraph() {
    if (graphAnimated) return;
    graphAnimated = true;

    // Hide change indicator initially
    if (graphTooltipChange) {
      graphTooltipChange.style.display = 'none';
    }

    // Animate baseline first
    const baselineInterval = setInterval(function() {
      if (baselineValue >= 100) {
        clearInterval(baselineInterval);
        baselineValue = 100;
        // Start natty animation after baseline completes
        startNattyAnimation();
      } else {
        baselineValue += 2;
      }
      updateGraph();
    }, 30);
  }

  function startNattyAnimation() {
    const nattyInterval = setInterval(function() {
      if (nattyValue >= 127) {
        clearInterval(nattyInterval);
        nattyValue = 127;
        if (graphTooltipChange) {
          graphTooltipChange.style.display = 'inline';
        }
      } else {
        nattyValue += 1.5;
      }
      updateGraph();
    }, 30);
  }

  function updateGraph() {
    const graphHeight = 160;

    // Update baseline line and dot
    if (graphBaseline && baselineValue > 0) {
      const baselineY = graphHeight - (100 / 150) * graphHeight;
      const baselineX = Math.min((baselineValue / 100) * 150, 150);
      graphBaseline.setAttribute('d', 'M 0 ' + baselineY + ' L ' + baselineX + ' ' + baselineY);
    }

    if (graphBaselineDot && baselineValue > 0) {
      const baselineY = graphHeight - (100 / 150) * graphHeight;
      const baselineX = Math.min((baselineValue / 100) * 150, 150);
      graphBaselineDot.setAttribute('cx', baselineX);
      graphBaselineDot.setAttribute('cy', baselineY);
      graphBaselineDot.style.opacity = baselineValue >= 100 ? '1' : '0';
    }

    // Update natty line
    if (graphNattyLine && nattyValue > 0) {
      const startY = graphHeight - (100 / 150) * graphHeight;
      const endY = graphHeight - (nattyValue / 150) * graphHeight;
      const progress = Math.min((nattyValue - 100) / 27 * 250, 250);

      if (nattyValue <= 100) {
        graphNattyLine.setAttribute('d', 'M 150 ' + startY + ' L 150 ' + startY);
      } else {
        const midX = 150 + progress * 0.4;
        const midY = startY - (startY - endY) * 0.6;
        graphNattyLine.setAttribute('d', 'M 150 ' + startY + ' Q ' + midX + ' ' + midY + ' ' + (150 + progress) + ' ' + endY);
      }
    }

    // Update natty dot and glow
    if (graphNattyDot && nattyValue > 100) {
      const endY = graphHeight - (nattyValue / 150) * graphHeight;
      const progress = Math.min((nattyValue - 100) / 27 * 250, 250);
      graphNattyDot.setAttribute('cx', 150 + progress);
      graphNattyDot.setAttribute('cy', endY);
      graphNattyDot.style.opacity = '1';
    }

    if (graphGlow && nattyValue > 100) {
      const endY = graphHeight - (nattyValue / 150) * graphHeight;
      const progress = Math.min((nattyValue - 100) / 27 * 250, 250);
      graphGlow.setAttribute('cx', 150 + progress);
      graphGlow.setAttribute('cy', endY);
      graphGlow.style.opacity = '1';
    }

    // Update tooltip values
    if (graphTooltipBaselineValue) {
      graphTooltipBaselineValue.textContent = Math.round(baselineValue) + '%';
    }

    if (graphTooltipNattyValue && nattyValue > 0) {
      graphTooltipNattyValue.textContent = Math.round(nattyValue) + '%';
    }
  }

  // Intersection Observer for graph animation
  if (graphSection) {
    const graphObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
          animateGraph();
          graphObserver.unobserve(entry.target);
        }
      });
    }, { threshold: [0.3] });

    graphObserver.observe(graphSection);
  }

  // =============================================
  // Features Bar Slide-In Animation
  // =============================================
  const featuresSection = document.querySelector('.features');
  const featureItems = document.querySelectorAll('.features__item');

  if (featuresSection && featureItems.length > 0) {
    const featuresObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          featureItems.forEach(function(item) {
            item.classList.add('animate-in');
          });
          featuresObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    featuresObserver.observe(featuresSection);
  }

  // =============================================
  // General Scroll Animation Observer
  // =============================================
  const animatedElements = document.querySelectorAll('[data-animate]');

  if (animatedElements.length > 0) {
    const scrollObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const delay = entry.target.style.getPropertyValue('--delay') || '0s';
          setTimeout(function() {
            entry.target.classList.add('animate-in');
          }, parseFloat(delay) * 1000);
          scrollObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    animatedElements.forEach(function(el) {
      scrollObserver.observe(el);
    });
  }

  // =============================================
  // Organ Benefits Chart Animation
  // =============================================
  const organChart = document.querySelector('.organ-chart');

  if (organChart) {
    const chartBars = organChart.querySelectorAll('.organ-chart__bar-group');
    const chartObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          chartBars.forEach(function(bar, index) {
            setTimeout(function() {
              bar.classList.add('animate-in');
            }, index * 150);
          });
          chartObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    chartObserver.observe(organChart);
  }

  // =============================================
  // Organ Stats Animation
  // =============================================
  const organStats = document.querySelectorAll('.organ-stat');

  if (organStats.length > 0) {
    const statsObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const delay = entry.target.style.getPropertyValue('--delay') || '0s';
          setTimeout(function() {
            entry.target.classList.add('animate-in');
          }, parseFloat(delay) * 1000);
          statsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    organStats.forEach(function(stat) {
      statsObserver.observe(stat);
    });
  }

  // =============================================
  // Pause Carousels on Hover and Touch/Scroll
  // =============================================
  const carouselTracks = document.querySelectorAll('.products__track, .ingredients__track');

  carouselTracks.forEach(function(track) {
    let scrollTimeout;
    const carousel = track.parentElement;

    // Pause on hover
    track.addEventListener('mouseenter', function() {
      this.style.animationPlayState = 'paused';
    });

    track.addEventListener('mouseleave', function() {
      this.style.animationPlayState = 'running';
    });

    // Pause on touch start
    carousel.addEventListener('touchstart', function() {
      track.classList.add('is-scrolling');
      track.style.animationPlayState = 'paused';
    }, { passive: true });

    // Resume after touch ends (with delay)
    carousel.addEventListener('touchend', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        track.classList.remove('is-scrolling');
        track.style.animationPlayState = 'running';
      }, 2000);
    }, { passive: true });

    // Pause on scroll
    carousel.addEventListener('scroll', function() {
      track.classList.add('is-scrolling');
      track.style.animationPlayState = 'paused';

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        track.classList.remove('is-scrolling');
        track.style.animationPlayState = 'running';
      }, 2000);
    }, { passive: true });
  });

  // =============================================
  // Product Card Hover Effects
  // =============================================
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      this.style.borderColor = 'var(--blue)';
      this.style.transform = 'translateY(-8px)';
      this.style.boxShadow = '0 20px 60px rgba(0, 159, 255, 0.2)';
    });

    card.addEventListener('mouseleave', function() {
      this.style.borderColor = 'rgba(168, 178, 193, 0.1)';
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = 'none';
    });
  });

  // =============================================
  // Button Hover Effects
  // =============================================
  const glowButtons = document.querySelectorAll('.btn--glow');

  glowButtons.forEach(function(btn) {
    btn.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-3px)';
      this.style.boxShadow = '0 0 60px rgba(0, 159, 255, 0.6)';
    });

    btn.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 0 40px rgba(0, 159, 255, 0.4)';
    });
  });

  const ctaButton = document.querySelector('.cta__button');

  if (ctaButton) {
    ctaButton.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.05)';
      this.style.boxShadow = '0 0 80px rgba(0, 159, 255, 0.7)';
    });

    ctaButton.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1)';
      this.style.boxShadow = '0 0 60px rgba(0, 159, 255, 0.5)';
    });
  }

  // =============================================
  // Secondary Button Hover
  // =============================================
  const secondaryButtons = document.querySelectorAll('.btn--secondary');

  secondaryButtons.forEach(function(btn) {
    btn.addEventListener('mouseenter', function() {
      this.style.borderColor = 'var(--blue)';
      this.style.color = 'var(--blue)';
    });

    btn.addEventListener('mouseleave', function() {
      this.style.borderColor = 'var(--silver-dark)';
      this.style.color = 'var(--silver-light)';
    });
  });

  // =============================================
  // Instagram Items Hover
  // =============================================
  const instaItems = document.querySelectorAll('.instagram__item');

  instaItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      this.style.borderColor = 'var(--blue)';
      this.style.background = 'rgba(0, 159, 255, 0.1)';
    });

    item.addEventListener('mouseleave', function() {
      this.style.borderColor = 'var(--silver-dark)';
      this.style.background = 'rgba(0, 159, 255, 0.05)';
    });
  });

});
